import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { KeycloakService , KeycloakAuthGuard } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard extends KeycloakAuthGuard {

  constructor(protected router: Router, protected keycloak: KeycloakService) {
    super(router, keycloak);
  }

  async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    console.log("auth",this.authenticated);
    // if (this.authenticated) {
    //   return true;
    // }
    // await this.keycloak.login({
    //   redirectUri: window.location.origin + "/participants",
    //   //maxAge: 60,
    // });

    if (!this.authenticated) {
       await this.keycloak.login({
         redirectUri: window.location.origin + "/participants",
         // prompt: 'login',
         // maxAge: 60,
       });
    }
    return this.authenticated;
  }
}
